import { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { IoArrowBackCircleSharp } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import collabCheckListApi from "../../../api/collabCheckListApi";
import collabDocumentsApi from "../../../api/collabDocumentsApi";
import collaborationApi from "../../../api/collaborationApi";
import companyApi from "../../../api/company";
import companyUserApi from "../../../api/companyUsers";
import creditRequestApi from "../../../api/creditRequestApi";
import CollabContributors from "./CollabContributors";
import "./collab.css";

const CollabOverview = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("user"));
  const senderEmail = user?.userEmail;
  const [contributors, setContributors] = useState([]);
  const [collabCharge, setCollabCharge] = useState(0);
  const [collaborationCharge, setCollaborationCharge] = useState(0);
  const [formData, setFormData] = useState({
    collaborationName: "",
    forType: "Company",
    companyOrPerson: "",
    createdOn: new Date().toISOString().split("T")[0],
    deadline: "",
    cost: "",
    costChargedTo: "Client",
    createdBy: senderEmail || "",
  });
  const [userCredits, setUserCredits] = useState([]);
  const [userCompanies, setUserCompanies] = useState([]);
  const [assignedCompanies, setAssignedCompanies] = useState([]);
  const [collaborationCompanies, setCollaborationCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const creditDeduction = formData.forType === "Company" ? 2 : 1;
  const originalBalance = userCredits?.balanceCredit || 0;
  const originalUsed =
    userCredits?.usedCredit || userCredits?.usedFreeToday || 0;
  const creditsBought = userCredits?.creditBought || 0;
  const originalFreeBalance = userCredits?.freeFrymesBalance || 0;

  let predictedFreeBalance = originalFreeBalance;
  let predictedBalance = originalBalance;

  const predictedUsed = originalUsed + creditDeduction;
  const distinctCompanies = Array.from(
    new Map(
      [...userCompanies, ...assignedCompanies, ...collaborationCompanies].map(
        (c) => [c.companyName, c],
      ),
    ).values(),
  );

  useEffect(() => {
    fetchUserCredits();
  }, []);
  const fetchUserCredits = async () => {
    try {
      const response = await creditRequestApi.getUserCredits(senderEmail);
      setUserCredits(response.data);
    } catch (error) {
      console.error("Error fetching user credits", error);
    }
  };

  useEffect(() => {
    const templateState = location.state;
    if (templateState) {
      setFormData((prev) => ({
        ...prev,
        collaborationName:
          templateState.collaborationName || prev.collaborationName,
        checklist: templateState.checklist || [],
        documents: templateState.documents || [],

        fileName:
          templateState.documents?.length > 0
            ? templateState.documents[0].documentName
            : "",

        description:
          templateState.documents?.length > 0
            ? templateState.documents[0].description
            : "",

        file:
          templateState.documents?.length > 0
            ? templateState.documents[0].file
            : null,

        forCompany: templateState.forCompany ?? prev.forCompany,
        forPerson: templateState.forPerson ?? prev.forPerson,
        companyOrPerson:
          templateState.companyName || templateState.personName || "",
        customCompanyName:
          templateState.companyName === "OTHER"
            ? ""
            : templateState.companyName || "",
        deadline: templateState.deadline || prev.deadline,
        cost: templateState.cost || prev.cost,
        documents: templateState.documents || [],
      }));
    }
  }, [location.state]);

  useEffect(() => {
    const fetchUserCompanies = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user) return;

        const getComapnies = await collaborationApi.getCompanies();
        const formattedCompanies = (getComapnies.data || []).map(
          (name, index) => ({
            id: "collab-" + index,
            companyName: name.trim(),
          }),
        );
        setCollaborationCompanies(formattedCompanies);

        console.log("Company Names from Collab API:", getComapnies.data);
        const response = await companyApi.getListOfCompanyByAdminEmail(
          user.userEmail,
        );
        setUserCompanies(response.data || []);

        const assignedResponse =
          await companyUserApi.getAssignedCompaniesFromAdmin(user.userEmail);
        setAssignedCompanies(assignedResponse.data || []);
      } catch (error) {
        console.error("Error fetching user companies:", error);
      }
    };

    fetchUserCompanies();
  }, []);

  // Set default deadline (10 days from today)
  useEffect(() => {
    const today = new Date();
    const deadline = new Date(today);
    deadline.setDate(today.getDate() + 5);
    setFormData((prevFormData) => ({
      ...prevFormData,
      deadline: deadline.toISOString().split("T")[0],
    }));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // If selecting OTHER, keep dropdown value = "OTHER"
    if (name === "companyOrPerson" && value === "OTHER") {
      setFormData({
        ...formData,
        companyOrPerson: "OTHER",
        customCompanyName: "", // reset input
      });
      return;
    }

    // Custom company typing should NOT touch dropdown selection
    if (name === "customCompanyName") {
      setFormData({
        ...formData,
        customCompanyName: value,
        // Keep companyOrPerson as "OTHER" so the input stays visible
      });
      return;
    }

    // Default update
    setFormData({ ...formData, [name]: value });
  };

  // useEffect(() => {
  //   adminApi
  //     .getCreditSettings()
  //     .then((res) => {
  //       setCollabCharge(res.data.collabCharge);
  //     })
  //     .catch((err) => {
  //       console.error("Failed to load credit settings", err);
  //       Swal.fire(
  //         "Error",
  //         "Unable to load credit settings from server.",
  //         "error",
  //       );
  //     });
  // }, []);

  useEffect(() => {
    if (senderEmail) {
      collaborationApi
        .getTotalCollabCharge(senderEmail)
        .then((res) => {
          setCollaborationCharge(res.data || 0);
        })
        .catch((err) => {
          console.error("Failed to load collaboration charge", err);
          Swal.fire(
            "Error",
            "Unable to load remaining collaboration charge.",
            "error",
          );
        });
    }
  }, [senderEmail]);

  const totalCollabCharge = (collabCharge || 0) - (collaborationCharge || 0);

  function base64ToFile(base64, fileName, fileType) {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: fileType });

    return new File([blob], fileName, { type: fileType });
  }
  const handleSubmit = async (e) => {
    if (originalBalance + originalFreeBalance < creditDeduction) {
      Swal.fire(
        "Insufficient Personal Frymes",
        "You do not have enough frymes to create a collaboration.",
        "error",
      );
      return;
    }
    // Duplicate contributor validation
    const duplicateContributor = contributors.find(
      (contributor, index) =>
        contributors.findIndex(
          (c) =>
            c.email.trim().toLowerCase() ===
              contributor.email.trim().toLowerCase() &&
            c.role === contributor.role,
        ) !== index,
    );

    if (duplicateContributor) {
      Swal.fire({
        icon: "error",
        title: "Duplicate Contributor",
        text: `Email ${duplicateContributor.email} already exists with role ${duplicateContributor.role}`,
      });
      return;
    }
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        collaborationName: formData.collaborationName?.trim(),
        forCompany: formData.forType === "Company",
        companyName:
          formData.forType === "Company"
            ? formData.companyOrPerson === "OTHER"
              ? formData.customCompanyName?.trim()
              : formData.companyOrPerson?.trim()
            : null,

        forPerson: formData.forType === "Person",

        personName:
          formData.forType === "Person"
            ? formData.companyOrPerson?.trim()
            : null,

        createdOn: formData.createdOn,
        deadline: formData.deadline,
        cost: Number(formData.cost) || 0,
        costChargedTo: formData.costChargedTo || "Client",
        createdBy: formData.createdBy,

        checklist: Array.isArray(formData.checklist)
          ? formData.checklist
              .map((item) => (typeof item === "string" ? item : item.item))
              .join(",")
          : "",

        collabDTOs: contributors.map((c) => ({
          name: c.name,
          email: c.email,
          role: c.role || "Contributor",
        })),
      };

      const response = await collaborationApi.saveCollaborationInfo(payload);

      if (response.status === 200 || response.status === 201) {
        const collabId = response.data.id;

        if (
          Array.isArray(formData.documents) &&
          formData.documents.length > 0
        ) {
          await Promise.all(
            formData.documents.map(async (doc) => {
              let fileToUpload = doc.file;

              // Convert Base64 to File if needed
              if (typeof doc.file === "string") {
                fileToUpload = base64ToFile(
                  doc.file,
                  doc.documentName,
                  doc.fileType,
                );
              }

              const uploadFormData = new FormData();
              uploadFormData.append("file", fileToUpload);

              const metadata = {
                documentName: doc.documentName,
                description: doc.description,
                uploadedBy: formData.createdBy,
                collabId: collabId,
                collabName: formData.collaborationName,
              };

              uploadFormData.append(
                "data",
                new Blob([JSON.stringify(metadata)], {
                  type: "application/json",
                }),
              );

              return collabDocumentsApi.uploadDocument(uploadFormData);
            }),
          );
        }
        if (
          Array.isArray(formData.checklist) &&
          formData.checklist.length > 0
        ) {
          await Promise.all(
            formData.checklist.map((itemValue) => {
              const itemName =
                typeof itemValue === "string" ? itemValue : itemValue.item;

              return collabCheckListApi.addChecklist({
                item: itemName.trim(),
                status: false,
                collabName: formData.collaborationName,
                addedBy: formData.createdBy,
                collabId: collabId,
              });
            }),
          );
        }

        // await creditRequestApi.updateUserCredits({
        //   email: senderEmail,
        //   creditDeduction: creditDeduction,
        // });
        // await adminUserCreditApi.saveCreditTransaction({
        //   SenderEmail: senderEmail,
        //   usedCredits: predictedUsed,
        //   balanceCredits: predictedBalance,
        //   creditsBought,
        //   date: new Date().toISOString(),
        //   // collabId: response.data.collabUniqueId,
        //   // collabName: formData.collaborationName,
        // });
        Swal.fire({
          icon: "success",
          title: "Collaboration Created!",
          text: "Main record, documents, and checklist items saved successfully.",
          confirmButtonText: "OK",
        }).then(() => navigate("/dashboard/my-collabs?tab=all-collabs"));
      } else {
        throw new Error("Initial collaboration save failed");
      }
    } catch (error) {
      console.error(
        "Submission Error Details:",
        error.response?.data || error.message,
      );

      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while saving. Please check your inputs.";

      Swal.fire({
        icon: "error",
        title: "Save Failed",
        text: errorMessage,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="scrollable-container" style={{ height: "100%" }}>
      <div className="header-container">
        <h1>
          <strong>Add New Collaboration</strong>
        </h1>
        <Button onClick={handleBack} variant="info" className="tooltip-btn">
          <IoArrowBackCircleSharp />
          <span className="tooltip-text">Go to Back</span>
        </Button>
      </div>
      <div>
        Template details
        <p>{formData.description}</p>
        <p>{formData.fileName && `File: ${formData.fileName}`}</p>
        <p>{formData.checklist && `Checklist: ${formData.checklist}`}</p>
      </div>

      <Card className="p-4 shadow-sm">
        <h5 className="mb-3">🗂️ Collaboration Overview</h5>
        <p>
          <strong>Free frymes:</strong> {userCredits?.freeFrymesBalance || 0}
          &nbsp;||&nbsp;
          <strong>Used Free frymes:</strong> {userCredits?.usedFreeToday || 0}
          &nbsp;||&nbsp;
          <strong>Total paid frymes:</strong> {userCredits?.creditBought || 0}{" "}
          &nbsp;||&nbsp;
          <strong>Balance paid frymes:</strong>{" "}
          {userCredits?.balanceCredit || 0} &nbsp;||&nbsp;
          <strong>Used frymes:</strong> {userCredits?.usedCredit || 0}
        </p>

        {userCredits?.freeFrymesBalance === 0 && (
          <p style={{ color: "red" }}>
            Your monthly free frymes have been exhausted. Please wait until next
            month for renewal.
          </p>
        )}
        <div
          className="alert alert-info"
          style={{
            borderLeft: "5px solid #ae00ff",
            fontSize: "15px",
          }}
        >
          <strong>Important:</strong>

          <ul className="mb-0 mt-2">
            <li>
              Creating a collaboration deducts <strong>2 frymes</strong> for a
              company collaboration and <strong>1 fryme</strong> for a
              person-to-person collaboration.
            </li>

            <li>
              Every new collaboration is allocated{" "}
              <strong>10 base collaboration frymes</strong>.
            </li>

            <li>
              <strong>
                2 collaboration frymes are deducted automatically every day
              </strong>
              , regardless of whether the collaboration is used.
            </li>

            <li>
              The collaboration remains active for <strong>5 days</strong> by
              default.
            </li>

            <li>
              After 5 days, if no additional time has been purchased, the
              collaboration will become <strong>Inactive</strong>.
            </li>

            <li>
              Once inactive, you will{" "}
              <strong>
                not be able to assign tasks, upload documents, or perform
                collaboration activities
              </strong>{" "}
              until the collaboration is extended or upgraded.
            </li>
          </ul>
        </div>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="collaborationName">
                <Form.Label>Collaboration Name</Form.Label>
                <Form.Control
                  type="text"
                  name="collaborationName"
                  value={formData.collaborationName}
                  onChange={handleChange}
                  placeholder="Enter collaboration name: Title - org / person"
                  required
                />
              </Form.Group>
              <p>
                E.g., Contract – ABC Corp, NDA – John Doe, Invoice – Vendor X
              </p>
            </Col>

            <Col md={3}>
              <Form.Group className="mb-3" controlId="forType">
                <Form.Label>For</Form.Label>
                <Form.Select
                  name="forType"
                  value={formData.forType}
                  onChange={handleChange}
                >
                  <option>Company</option>
                  <option>Person</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group className="mb-3" controlId="companyOrPerson">
                <Form.Label>
                  {formData.forType === "Company"
                    ? "Company Name"
                    : "Person Name"}
                </Form.Label>

                {formData.forType === "Company" && (
                  <>
                    <Form.Select
                      name="companyOrPerson"
                      value={formData.companyOrPerson}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select a company</option>

                      {distinctCompanies.map((c) => (
                        <option key={c.id} value={c.companyName}>
                          {c.companyName}
                        </option>
                      ))}

                      <option value="OTHER">other</option>
                    </Form.Select>

                    {formData.companyOrPerson === "OTHER" && (
                      <Form.Control
                        type="text"
                        name="customCompanyName"
                        placeholder="Enter company name"
                        value={formData.customCompanyName || ""}
                        onChange={handleChange}
                        className="mt-2"
                        required
                      />
                    )}
                  </>
                )}

                {formData.forType === "Person" && (
                  <Form.Control
                    type="text"
                    name="companyOrPerson"
                    value={formData.companyOrPerson}
                    onChange={handleChange}
                    placeholder="Enter person name"
                  />
                )}

                {/* {formData.companyOrPerson === "OTHER" && (
                  <Form.Control
                    type="text"
                    name="customCompanyName"
                    placeholder="Enter company name"
                    value={formData.customCompanyName || ""}
                    onChange={handleChange}
                    className="mt-2"
                    required
                  />
                )} */}
              </Form.Group>
            </Col>
          </Row>

          <CollabContributors
            contributors={contributors}
            setContributors={setContributors}
          />

          {/* <p>
            <strong>
              Note: Base collaboration charge is 5 credits for 10 days. If you
              want to extend the duration, an additional 0.5 credits per day
              will be charged.
            </strong>
          </p> */}

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="createdOn">
                <Form.Label>Created On</Form.Label>
                <Form.Control
                  type="date"
                  name="createdOn"
                  value={formData.createdOn}
                  onChange={handleChange}
                  disabled
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3" controlId="deadline">
                <Form.Label>Deadline</Form.Label>
                <Form.Control
                  type="date"
                  name="deadline"
                  value={formData.deadline}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Collaboration Duration</Form.Label>
                <Form.Control type="text" value="5 Days" disabled />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3" controlId="cost">
                <Form.Label>Price of collaboration</Form.Label>
                <Form.Control
                  type="number"
                  name="cost"
                  value={formData.cost}
                  onChange={handleChange}
                  placeholder={`Collaboration ${formData.cost} Price`}
                  max={formData.cost}
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3" controlId="costChargedTo">
                <Form.Label>Cost Charged To</Form.Label>
                <Form.Select
                  name="costChargedTo"
                  value={formData.costChargedTo}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  {formData.forType === "Company" &&
                    formData.companyOrPerson && (
                      <option
                        value={
                          formData.companyOrPerson === "OTHER"
                            ? formData.customCompanyName
                            : formData.companyOrPerson
                        }
                      >
                        {formData.companyOrPerson === "OTHER"
                          ? formData.customCompanyName ||
                            "Other (enter name above)"
                          : formData.companyOrPerson}
                      </option>
                    )}
                  {contributors.map((c, index) => (
                    <option key={index} value={c.email}>
                      {c.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <div className="text-end mt-3">
            <Button
              variant="success"
              type="submit"
              className="me-2"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Saving...
                </>
              ) : (
                "💾 Save"
              )}
            </Button>
            <Button
              variant="danger"
              onClick={() => {
                /* Implement delete logic */
              }}
            >
              🗑️ Delete
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default CollabOverview;
